/*
		class.js,
			A pythonic class implementation for javascript.
 */

function method(o, f) {
	return function() {
		return f.apply(o, arguments);
	}
}

module.exports = function(base, props) {		// Class
	var cls = function() {
		if(this.__init__) {
			this.__init__.apply(this, arguments);
		}
	}

	if(base) {
		for(var key in base) {
			cls[key] = base[key];
		}
	}

	for(var key in props) {
		cls[key] = props[key];
	}

	cls.prototype = cls;
	return cls;
}

